module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter7"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006toc#ch07"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several days later, Barry went with Tory for her first prenatal visit. He had been humming and grinning ever since they’d learned about the baby, but she had convinced him to keep it quiet until the doctor confirmed that the at-home test was accurate. She didn’t want the kids getting all excited if it turned out to be a mistake. Still, he had gone up to the attic and gotten down the maternity clothes and all the baby clothes they had put away, and had begun drawing up plans to build an extra room onto their house. She hid all the clothes from the children, and shushed Barry over and over so he wouldn’t give it away. But the blood test she took confirmed her pregnancy in a matter of minutes, and the ultrasound showed a tiny little fetus with a strong heartbeat. They couldn’t have been more thrilled if it had been their first child.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Grentwell sat down and began going over the routine for prenatal care. They listened, holding hands, nodding as he spoke, for none of this was new to them. The doctor was a "), _c('a', {
    attrs: {
      "id": "page43"
    }
  }), _vm._v("painfully thin man who looked as if he needed medical care himself, and he spoke like a flight attendant who’d made the same speech five thousand times. As he spoke, he jotted prescriptions for prenatal vitamins, which Tory already had, and nausea pills, which she had no intentions of taking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You realize, don’t you, that we consider someone of your age to be at a higher risk in pregnancy than a younger woman?” he asked in a matter-of-fact monotone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tory bristled. “Someone of my age?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you just turned thirty-five. The risk of chromosomal problems in the baby is higher, and we recommend that all of our obstetric patients who will be thirty-five or older at the birth of their babies have a CVS or an amniocentesis. It’s a little early for an amnio, but since you’re ten weeks, we could go ahead and do the CVS.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s a CVS?” Tory asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chorionic villi sampling is a relatively new procedure, where we get samples of tissue from the placenta. Those cells are fetal cells, so we can culture them. In a week to ten days, we can determine the chromosomal makeup of those cells.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tory thought that over for a moment. “Do I have to have that test? What if I opt out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You certainly have that option.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Barry said. “We need to have it done. She’s a worrier, and if we don’t know, she’ll worry about it the whole pregnancy, just based on what you said about women over thirty-five. I’d rather rule out that kind of problem from the start. Besides, if there’s something wrong, I want to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t matter,” she said. “Even if something was wrong, I would never terminate a pregnancy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A lot of women say that,” Dr. Grentwell said, tapping his pencil against his pad. “But I recommend the test, because if your baby has Down’s Syndrome or another chromosomal defect, it might take you several months to prepare yourself. Not only that, it’s helpful if we know there could be problems when the baby comes, so we’re prepared to treat them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }), _vm._v("He stood up, and Tory noted that the man needed a wife to tell him that his pants were pulled up too high, and that his limegreen shirt didn’t quite match the army-green pants he wore under his lab coat. His brown socks made her wonder if he was color blind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So what do you think?” Barry asked, nudging her. “You know there’s nothing wrong. But you also know that you’ll obsess about it for the next six months if you don’t rule it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sighed. “Okay, we’ll do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man sat back down then, his bony elbows on his bony knees, and began his next rote speech on the minor risks involved with the procedure.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ceb5fd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013-chapter7.vue
// module id = 87
// module chunks = 0